import applyConfig from './config';


export default applyConfig;